import React from 'react';
import clsx from 'clsx';
import { useSanitize } from '../../hooks/useSanitize';
import * as Styled from './ASubheader.styles';
import { ASubheaderSize, ASubheaderTag, type ASubheaderProps } from './ASubheader.types';

const COMPONENT_NAME = 'a-web-ui-kit-ASubheader';
const TEST_ID = 'web-ui-kit-ASubheader';

const ASubheaderAllowedTags = ['sub', 'sup', 'br', 'span'];
const sanitizeOpts = { ALLOWED_TAGS: ASubheaderAllowedTags };

function ASubheader({
  text,
  size = ASubheaderSize.L,
  element,
  className,
  ...rest
}: ASubheaderProps) {
  const sizeClassMap = {
    [ASubheaderSize.XL]: 't-subtitle-xl',
    [ASubheaderSize.L]: 't-subtitle-l',
    [ASubheaderSize.M]: 't-subtitle-m',
    [ASubheaderSize.S]: 't-subtitle-s',
  };

  const mergedClassName = clsx(sizeClassMap[size], className);
  const Tag = element ?? ASubheaderTag.h2;

  const { isDangerouslySet, result: cleanText } = useSanitize(text, sanitizeOpts);

  return isDangerouslySet ? (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      as={Tag}
      className={mergedClassName}
      {...rest}
      dangerouslySetInnerHTML={{ __html: cleanText }}
    />
  ) : (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      as={Tag}
      className={mergedClassName}
      {...rest}
    >
      {cleanText}
    </Styled.Wrapper>
  );
}

export { ASubheader, ASubheaderSize, ASubheaderTag, TEST_ID as A_SUBHEADER_TEST_ID };